import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ac-type-10-icon',
  templateUrl: './ac-type-10-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AcType10IconComponent {}
